<template>
	<div class="his-order-list-div box">
		<ComNar title = "我的优惠券"></ComNar>
		<van-empty v-if="couponData.length == 0" description="暂无优惠券" />
		<div class="coupon-list">
			<div class="list-box">
				<div class="item" v-for="(item,index) in couponData" :key="index">
					<div class="item-left">
						<img src="../assets/xingbake_1.png" alt="">

					</div>
					<div class="item-content">
						<div class="item-name">{{parseFloat(item.price) == 38?'中杯通兑券':item.priceHint + '元在线点单代金券'}}-{{item.statusHint}}</div>
						<div style="color: #414141;">优惠券码：{{item.ticketCode}}</div>
						<div style="color: #666;">本券不找零不兑现，不可拆分使用</div>
						<div style="color: #999999;">有效期至：{{item.expireDate}}</div>
					</div>
					<div class="item-right-btn" :class="item.status == 3?'':'gray'" @click="goUse(item)">去使用</div>
				</div>
			</div>
		</div>

		<van-button text="添加优惠券" class="add-btn" :color="this.$enum.CONSTANT.APP_THEME_COLOR" @click="open()"/>
		<van-action-sheet v-model="show" title="添加优惠券" >
			<div class="content">
				<van-field v-model="code" center clearable label="兑换码" placeholder="请输入兑换码">
					<template #button>
						<van-button size="small" type="primary" color="rgb(0, 110, 63)" @click="addCouponBtn()">兑换</van-button>
					</template>
				</van-field>
			</div>
		</van-action-sheet>
	</div>

</template>

<script>
	import ComNar from '@/components/searchShop/ComNar.vue'
	import {
		getCouponList,
		addCoupon
	} from '@/request/api';
	import {
		Button,
		Empty,
		Field,
		ActionSheet,
		Notify
	} from 'vant';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex";
	export default {
		name: 'Coupon',
		components: {
			[Button.name]: Button,
			[Empty.name]: Empty,
			[Field.name]: Field,
			[ActionSheet.name]: ActionSheet,
			[Notify.name]: Notify,
			[ComNar.name]: ComNar,
		},
		data() {
			return {
				page: 1, //查询页码
				limit: 9999, //每页大小
				couponData: [
					
				],
				show: false,
				code: null
			}
		},
		created() {
			this.loadList();
		},


		methods: {
			...mapMutations(['sSetCouponId']),
			open(){
				this.show = true,
				this.code = null;
			},
			goUse(item){
				let data = JSON.stringify(item) 
				if(item.status == 3){
					this.sSetCouponId(item.couponId)
					this.$router.push({
						name: 'searchShop',
					})
				}
			},
			addCouponBtn(){
				addCoupon(this.code).then((resolve) => {
					Notify({ type: 'success', message: '添加成功' });
					this.loadList();
					this.show = false;
				}).catch((error) => {
					
				})
				
			},
			loadList() {
				getCouponList().then((resolve) => {
					console.log(resolve)
					this.couponData = resolve.retData;

				}).catch((error) => {

				})
			},
			// addCoupon() {
			// 	uni.navigateTo({
			// 	    url: './exchange'
			// 	});
			// }
		}
	}
</script>

<style scoped>
	.content{
		padding: 40px 0  80px 0;
	}
	.box {
		width: 100%;
		min-height: 100%;
		background-color: #f6f6f6;
		position: relative;
		padding-bottom: 44px;
	}

	.his-order-list-div .van-empty {
		padding-top: 40px;
		background-color: #f6f6f6;
	}

	.pay-coupon-detail-div {
		background-color: #ffffff;
		margin-top: 10px;
		padding: 10px 0;

	}

	.coupon-box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-left: 5px;
	}

	.coupon-name {
		color: #999;
	}

	.coupon-num {
		color: #FD3E3F;
		font-size: 16px;
	}

	.list-box {
		padding: 15px;
		/* height: 400px; */
		overflow: auto;
		background: #f6f6f6;
	}

	.list-box {
		padding: 15px;
		background: #f6f6f6;
	}

	.list-box .item {
	  display: flex;
	  height: 100px;
	  background: #fff;
	  background-size: 100% 100%;
	  margin-bottom: 15px;
	  padding-left: 10px;
	  justify-content: space-between;
	  align-items: center;
	}

	.list-box .item .item-left {
		/* width: 333px; */
		display: flex;
		flex-direction: column;
		justify-content: center;
		/* padding-left: 40px; */
	}
		
	.list-box .item .item-content{
		font-size: 10px;
	}
	.item-content .item-name{
		font-size: 14px;
		font-weight: bold;
		margin-bottom: 8px;
	}
	.item-left img{
		width: 67px;
		height: 67px;
	}
	.item-right-btn{
		width: 78px;
		height: 29px;
		background: #006E3F;
		border-radius: 14px;
		font-size: 13px;
		color: #FFFFFF;
		line-height: 29px;
		text-align: center;
	}

	.list-box .item .item-goods-name {
		font-size: 12px;
		color: #666666;
		padding-left: 5px;
	}

	.list-box .item .item-goods-detail {
		display: flex;
		align-items: center;
	}

	.list-box .item .item-goods-detail .item-goods-name {
		color: #333;
		font-size: 14px;
	}

	.list-box .item .item-goods-price {
		font-size: 21px;
		display: flex;
		align-items: center;
		color: #f46921;
	}

	.list-box .item .item-goods-price .unit {
		font-size: 10px;
	}

	.list-box .item .item-time {
		color: #999;
		font-size: 10px;
		/* padding-top: 10px; */
	}
	

	.list-box .item .item-right {
		/* width: 130px; */
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		color: #FE483A;
	}
	.item-right-btn.gray{
		background: #999;
	}
	.add-btn {
		width: 100%;
		position: absolute;
		bottom: 0;
	}
</style>
